export default __webpack_public_path__ + "static/media/cover-ewisemaps.ca9f5236.jpg";